import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios' 
import './assets/index.css'
import MaterialIcons from 'material-design-icons/iconfont/material-icons.css'
import JsonExcel from 'vue-json-excel' 
import Notifications from 'vue-notification'
import 'vue-snotify/styles/material.css';

import Snotify from 'vue-snotify'; // 1. Import Snotify
Vue.use(Snotify)
Vue.use(Notifications)
Vue.use(require('vue-moment'));
Vue.component('downloadExcel', JsonExcel)
Vue.config.productionTip = false
Vue.use(VueAxios, axios)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
